import { OrganizerForm } from "components/organizers";
import { useQueryOrganizer } from "hooks/organizers";
import { useQueryCurrentUser } from "hooks/users";
import { useParams } from "react-router-dom";

export const EditOrganizer = () => {
  const { uid } = useParams();
  const { user } = useQueryCurrentUser();

  // If we're on the /organizer route (no uid param), use the current user's organizer_id
  const organizerNumericId = user?.organizer_id;

  // When we have a URL parameter, use uid query, otherwise use numeric id query
  const queryParams = uid
    ? { uid }
    : organizerNumericId
    ? { id: organizerNumericId }
    : { uid: "" };

  const { isLoading, isError, error, organizer } =
    useQueryOrganizer(queryParams);

  if (isLoading) {
    return null;
  }
  if (isError) {
    return (
      <div>
        Something went wrong:
        {error?.message}
      </div>
    );
  }

  return <OrganizerForm organizer={organizer} />;
};
